export default function SchemaOrg() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://ilkeismakinalari.com';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'İlke İş Makinaları',
    url: siteUrl,
    logo: 'https://ilkeismakinalari.com/img/ilke-logo.png',
    description:
      'İlke İş Makinaları, 25 yıllık deneyimiyle Komatsu, Caterpillar, Volvo, Hidromek ve daha fazla marka için iş makinaları yedek parça tedariki yapan güvenilir çözüm ortağıdır.',
    sameAs: [
      'https://www.linkedin.com/company/ilke-ismakinalari',
      'https://www.instagram.com/ilkeismakinalari',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+90-536-432-25-18',
      contactType: 'Müşteri Hizmetleri',
      email: 'info@ilkeismakinalari.com',
      areaServed: 'TR',
      availableLanguage: 'Turkish',
    },
  };

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'AutoPartsStore',
    name: 'İlke İş Makinaları',
    image: [
      'https://ilkeismakinalari.com/img/home-background.jpg',
      'https://ilkeismakinalari.com/img/ilke-logo.png',
    ],
    url: siteUrl,
    telephone: '+90-536-432-25-18',
    email: 'info@ilkeismakinalari.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Eyüp Sultan, Cevahir Sk. No:14A',
      addressLocality: 'Sancaktepe',
      addressRegion: 'İstanbul',
      postalCode: '34791',
      addressCountry: 'TR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 41.0082,
      longitude: 28.9784,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '18:00',
      },
    ],
    priceRange: '$$',
    paymentAccepted: 'Nakit, Banka Havalesi',
    currenciesAccepted: 'TRY',
    areaServed: {
      '@type': 'Country',
      name: 'Türkiye',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'İlke İş Makinaları',
    url: siteUrl,
    inLanguage: 'tr-TR',
    publisher: {
      '@type': 'Organization',
      name: 'İlke İş Makinaları',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://ilkeismakinalari.com/img/ilke-logo.png',
      },
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'İlke İş Makinaları - İş Makinaları Yedek Parça Tedarikçisi',
    url: siteUrl,
    description:
      'Komatsu, Caterpillar, Volvo, Hidromek ve daha fazlası için iş makinaları yedek parça tedariki. 25 yıllık deneyimle İstanbul\'dan Türkiye geneline hızlı teslimat.',
    inLanguage: 'tr-TR',
    isPartOf: {
      '@type': 'WebSite',
      url: siteUrl,
      name: 'İlke İş Makinaları',
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: 'https://ilkeismakinalari.com/img/home-background.jpg',
      width: 1920,
      height: 1080,
    },
    datePublished: '2025-01-01T00:00:00+03:00',
    dateModified: '2026-05-21T00:00:00+03:00',
    mainEntity: {
      '@type': 'AutoPartsStore',
      name: 'İlke İş Makinaları',
      url: siteUrl,
    },
  };

  const aggregateRatingSchema = {
    '@context': 'https://schema.org',
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    bestRating: '5',
    worstRating: '1',
    reviewCount: '500',
    itemReviewed: {
      '@type': 'Organization',
      name: 'İlke İş Makinaları',
      url: siteUrl,
    },
  };

  const serviceListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Service',
          name: 'Orijinal ve Muadil Yedek Parça Temini',
          description:
            'Farklı marka ve model iş makinelerine uygun, yüksek kalite standartlarına sahip orijinal ve muadil yedek parçaları hızlı ve güvenilir şekilde temin ediyoruz.',
          provider: {
            '@type': 'Organization',
            name: 'İlke İş Makinaları',
            url: siteUrl,
          },
          areaServed: {
            '@type': 'Country',
            name: 'Türkiye',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Service',
          name: 'Hızlı Tedarik ve Lojistik',
          description:
            'Zamanın değerini biliyoruz. Güçlü tedarik ağımız sayesinde ihtiyaç duyulan parçaları en kısa sürede müşterilerimize ulaştırıyoruz.',
          provider: {
            '@type': 'Organization',
            name: 'İlke İş Makinaları',
            url: siteUrl,
          },
          areaServed: {
            '@type': 'Country',
            name: 'Türkiye',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Service',
          name: 'Teknik Destek ve Danışmanlık',
          description:
            'Alanında deneyimli ekibimizle, doğru parça seçimi ve kullanım süreçlerinde profesyonel destek sağlıyoruz.',
          provider: {
            '@type': 'Organization',
            name: 'İlke İş Makinaları',
            url: siteUrl,
          },
          areaServed: {
            '@type': 'Country',
            name: 'Türkiye',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@type': 'Service',
          name: 'Geniş Ürün Yelpazesi',
          description:
            'Motor parçalarından yürüyüş aksamına, hidrolik sistemlerden filtre gruplarına kadar iş makineleri için kapsamlı çözümler sunuyoruz.',
          provider: {
            '@type': 'Organization',
            name: 'İlke İş Makinaları',
            url: siteUrl,
          },
          areaServed: {
            '@type': 'Country',
            name: 'Türkiye',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 5,
        item: {
          '@type': 'Service',
          name: 'Güvenilir Hizmet Anlayışı',
          description:
            'Kalite, dürüstlük ve sürdürülebilir iş ortaklığı ilkeleriyle müşterilerimize uzun vadeli çözümler sunmayı hedefliyoruz.',
          provider: {
            '@type': 'Organization',
            name: 'İlke İş Makinaları',
            url: siteUrl,
          },
          areaServed: {
            '@type': 'Country',
            name: 'Türkiye',
          },
        },
      },
    ],
  };

  const brandListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Tedarik Ettiğimiz Markalar',
    itemListElement: [
      { '@type': 'ListItem', position: 1, item: { '@type': 'Brand', name: 'KOMATSU' } },
      { '@type': 'ListItem', position: 2, item: { '@type': 'Brand', name: 'CAT' } },
      { '@type': 'ListItem', position: 3, item: { '@type': 'Brand', name: 'HITACHI' } },
      { '@type': 'ListItem', position: 4, item: { '@type': 'Brand', name: 'VOLVO' } },
      { '@type': 'ListItem', position: 5, item: { '@type': 'Brand', name: 'LIEBHERR' } },
      { '@type': 'ListItem', position: 6, item: { '@type': 'Brand', name: 'HIDROMEK' } },
      { '@type': 'ListItem', position: 7, item: { '@type': 'Brand', name: 'JCB' } },
      { '@type': 'ListItem', position: 8, item: { '@type': 'Brand', name: 'CASE' } },
      { '@type': 'ListItem', position: 9, item: { '@type': 'Brand', name: 'NEW HOLLAND' } },
      { '@type': 'ListItem', position: 10, item: { '@type': 'Brand', name: 'HYUNDAI' } },
      { '@type': 'ListItem', position: 11, item: { '@type': 'Brand', name: 'DOOSAN' } },
      { '@type': 'ListItem', position: 12, item: { '@type': 'Brand', name: 'KUBOTA' } },
      { '@type': 'ListItem', position: 13, item: { '@type': 'Brand', name: 'BOBCAT' } },
      { '@type': 'ListItem', position: 14, item: { '@type': 'Brand', name: 'DANA' } },
      { '@type': 'ListItem', position: 15, item: { '@type': 'Brand', name: 'CARRARO' } },
      { '@type': 'ListItem', position: 16, item: { '@type': 'Brand', name: 'ZF' } },
      { '@type': 'ListItem', position: 17, item: { '@type': 'Brand', name: 'CUMMINS' } },
      { '@type': 'ListItem', position: 18, item: { '@type': 'Brand', name: 'KAWASAKI' } },
    ],
  };

  const schemas = [
    organizationSchema,
    localBusinessSchema,
    websiteSchema,
    webPageSchema,
    aggregateRatingSchema,
    serviceListSchema,
    brandListSchema,
  ];

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}